module.exports = __webpack_public_path__ + "img/3c-express.b5fe9303.png";